import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { EmployeeService } from "../../services/employeeService";

export const fetchEmployees = createAsyncThunk("employees/fetchEmployees",  async (_, { rejectWithValue }) => {
    try {
     //  const employees = await EmployeeService.getEmployees();
         // Convert each employee instance to a plain object
     // const plainEmployees = employees.map(employee => ({ ...employee }));
      
      return ;
    } catch (error) {
        return rejectWithValue(error.response?.data || "Error fetching orders");
    }
});

const EmployeeSlice = createSlice({
    name: "employees",
    initialState: {
        employees: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(fetchEmployees.pending, (state) => {
            state.loading = true;
            state.error = null;
          })
          .addCase(fetchEmployees.fulfilled, (state, action) => {
            state.loading = false;
            state.employees = action.payload;
          })
          .addCase(fetchEmployees.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          });
      },




});

export default EmployeeSlice.reducer;